import { AxiosResponse } from "axios";
import { updatePage } from "@/apps/merchant3/services/carts.service";
import { PagesTypes } from "@/apps/merchant3/types/PagesTypes";
import { store } from "@/shared-store";
import router from "@/router";
import { IVuexState } from "@/apps/merchant3/shared-models/IVuex";
import { Store } from "vuex";
import { SessionStorageEnum } from "@/apps/merchant3/enums/sessionStorageEnum";

export default function useUpdatePageState(): void {
  const vuexStore = store as unknown as Store<IVuexState>;

  if (!vuexStore.state.merchant.jwt) {
    if (sessionStorage.getItem(SessionStorageEnum.MerchantJwt)) {
      store.dispatch(
        "merchant/setMerchantJwt",
        sessionStorage.getItem(SessionStorageEnum.MerchantJwt)
      );
    }
  }

  const { cartTag } = vuexStore.state.carts;
  const routeName = router.currentRoute.value.name || "";

  const page = PagesTypes[routeName];
  if (!cartTag || !page) {
    return;
  }

  updatePage(cartTag, page).then((response: AxiosResponse) => {
    store.dispatch("carts/setCurrentPage", response.data.cart.currentPage);
  });
}
